import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FacetedSearch from '../Components/FacetedSearch';
import { query, searchFacetChange, sliderFilterChange, deselectAllFilterOptions, setShowAll, numberOfGroupsVisible } from '../Actions/FacetedSearch.action';

class FacetedSearchContainer extends Component {
    constructor(props) {
        super(props);
        this.handleFacetSearchActionLoading = this.handleFacetSearchActionLoading.bind(this);
        this.facetSearchElem = React.createRef()
        this.state = {
            isLoading:true,
        }
    }

    handleFacetSearchActionLoading(event) {
        this.setState((prevState, _) => { return { ...prevState, isLoading: event.detail.isLoading } });
    } 

    componentDidMount() {
        // listen to history events (back, forward) of window
        window.onpopstate = window.onpopstate || ((event) => {
            this.props.query(window.location.search.substr(1) || '', false, this.props.productId);
        })
        // Initial load on product-pages

        document.addEventListener('facetSearchActionLoading', this.handleFacetSearchActionLoading);

    }
    componentDidUpdate(prevProps) {       
        if (this.props.visibleGroups === 999) {
            this.checkFilterOverflow();
        }
    }
    componentWillUnmount() {
        document.removeEventListener('facetSearchActionLoading', this.handleFacetSearchActionLoading);
    }
    checkFilterOverflow () {
        const hasScroll = this.facetSearchElem.current.scrollWidth > this.facetSearchElem.current.clientWidth;
        this.props.setShowAll(!hasScroll);
        if (hasScroll) {
            let groupWidth = 0;
            let groupsShown = 0;
            const groups = this.facetSearchElem.current.children;
            const loadMoreElemWidth = document.getElementById("faceted-search__load-more").clientWidth;
            const renderContainer = this.facetSearchElem.current.clientWidth - loadMoreElemWidth;
            for (let index = 0; index < groups.length; index++) {
                const element = groups[index];
                const newWidth = groupWidth + element.clientWidth + 24; // margin
                if (newWidth < renderContainer) {
                    groupWidth = newWidth;                   
                    groupsShown++;
                }                
            }
            this.props.numberOfGroupsVisible(groupsShown);

        }
    }
    render() {
        return <FacetedSearch {...this.props} isLoading={this.state.isLoading} innerRef={this.facetSearchElem} />;
    }
}
const mapStateToProps = ({ facetedSearch: { facetFilters, showAll, visibleGroups, navigationTheme } }) => {
    return {
        facetFilters,
        showAll,
        visibleGroups,
        navigationTheme,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        query: (q, withHtmlResult, productId) => dispatch(query(q, withHtmlResult, productId)),
        setShowAll: (hasScroll) => dispatch(setShowAll(hasScroll)),
        numberOfGroupsVisible: (nrOfGroups) => dispatch(numberOfGroupsVisible(nrOfGroups)),
        searchFacetChange: (group, item, productId) => dispatch(searchFacetChange(group, item, productId)),
        sliderFilterChange: (group, value, productId) => dispatch(sliderFilterChange(group, value, productId)),
        deselectAllFilterOptions: (allFilters, productId) => dispatch(deselectAllFilterOptions(allFilters, productId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacetedSearchContainer);